import { render, staticRenderFns } from "./EditCasino.vue?vue&type=template&id=067a3c82&scoped=true&"
import script from "./EditCasino.vue?vue&type=script&lang=js&"
export * from "./EditCasino.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067a3c82",
  null
  
)

export default component.exports